import TabSection from './Tabs';

export default TabSection;
